module.exports = __webpack_public_path__ + "static/heroslider4-cff9aaf331da1e3728fa271f3e099553.jpg";